import React, { useEffect } from 'react'
import 'preline/preline'
import Navbar from './Navbar';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';

const Layout = ({children}) => {

    useEffect(() => {
        setTimeout(() => {
        if (
            window.HSStaticMethods &&
            typeof window.HSStaticMethods.autoInit === 'function'
        ) {
            window.HSStaticMethods.autoInit();
        }
        }, 100);
    }, []);

  return (
    <>

        <Helmet>
            <link rel="shortcut icon" href="/static/favicon.png" type="image/x-icon" />
        </Helmet>

        <BrowserRouter>
                <Navbar />
                    <div className="_clc_body">{children}</div>
        </BrowserRouter>

    </>
  )
}

export default Layout